import { IAuthState, AuthAction } from './types';
import {
    AUTH_LOADING,
    AUTH_SUCCESS,
    AUTH_ERROR,
    AUTH_LOGOUT,
    AUTH_TOKEN,
} from './constants';

export const initialState = {
  isLoading: true,
  hasResolved: false,
  error: '',
  isAuthenticated: false,
  token: '',
  tokenResolved: false,
  doesAccountExist: false,
  user: {
    id: '',
    email: '',
  }
};

export default (state: IAuthState, action: AuthAction) => {
  console.log('action.type')
  console.log(action.type)
  switch (action.type) {
    case AUTH_TOKEN:
      return {
        ...state,
        token: action.token || '',
        isLoading: action.isLoading,
        tokenResolved: true,
      }
    case AUTH_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case AUTH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasResolved: true,
        isAuthenticated: true,
        doesAccountExist: action.doesAccountExist,
        token: action.token,
        tokenResolved: true,
        user: {
          id: action.userId,
          email: action.email,
        }
      };
    case AUTH_ERROR:
      return {
        ...state,
        isLoading: false,
        hasResolved: true,
        error: action.message,
      };
    case AUTH_LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        token: '',
        user:{
          id: '',
          email: '',
        }
      };
    default:
      throw new Error();
  }
};